import { createContext } from 'react'
import { Position } from 'types'
import { ArtboardLayerRef } from '../types/refs'

type Props = {
    autoDuration: boolean
    crop?: Position
    duration: number
    fps: number
    height: number
    layers: ArtboardLayerRef[]
    paused: boolean
    scale: number
    width: number
    setDuration: (duration: number) => void
}

export const ArtboardContext = createContext({} as Props)
